import * as React from "react";
import {useEffect, useState} from "react";
import {PeriodService} from "../../../serverService/periodService/PeriodService";
import RaikoSelectBoxTypeTwo, {prepareRaikoSelectBoxTypeTwoItem} from "../raikoSelectBoxTypeTwo/RaikoSelectBoxTypeTwo";

const RaikoHostSelectBox = (
    {
        periodId = -1,
        isHorizontal = true,
        className = "",
        selectedHost = -1,
        setSelectedHost
    }) => {

    const service = new PeriodService();

    const [hosts, setHosts] = useState([])

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (typeof periodId !== "undefined" && periodId !== -1) {
            getHostListsFromServer()
        }
    }, [periodId]);

    function getHostListsFromServer() {
        setLoading(true)
        service.getHostsList(
            periodId,
            0,
            50
        ).then(response => {
            if (response.data.length > 0) {
                setHosts([]);
                response.data.map((item, index) => {
                    setHosts(prevState => [
                        ...prevState,
                        prepareRaikoSelectBoxTypeTwoItem(
                            item.id,
                            item.residence && item.residence.metaData ? item.residence.metaData.title : "",
                            item.clerk && item.clerk.metaData ? item.clerk.metaData.fullName : ""
                        )
                    ])
                })
                setSelectedHost(response.data[0].id)
            }
        }).catch(reason => {

        }).finally(() => {
            setLoading(false)
        })
    }


    return (
        <RaikoSelectBoxTypeTwo
            className={className}
            loading={loading}
            isHorizontal={isHorizontal}
            selectedItem={selectedHost}
            setSelectedItem={setSelectedHost}
            items={hosts}
        />
    )
};

export default RaikoHostSelectBox;
